import {Repo} from "../../../api/types";
import {Modal} from "../../Modal";
import LoadingContainer from "../../LoadingContainer";
import {useEffect, useState} from "react";
import {agent} from "../../../api/agent";
import styled from "styled-components";

interface Props {
    open: boolean;
    repo: Repo;
    onClose?: () => void;
}

const Container = styled.div`
    
    .item {
        padding: .5rem .5rem;
        cursor: pointer;
        &:hover {
            background-color: var(--content-box-border);
        }
    }
`

export default function BranchModel({
                                        open,
                                        repo,
                                        onClose = () => {}
}: Props) {

    const [branches, setBranches] = useState<string[] | undefined>(undefined);

    useEffect(() => {
        if (!open) {
            setBranches(undefined);
            return;
        }

        agent.getRepo(repo.withoutBranch).then(value => {
            setBranches(value.branches);
        });

    }, [open]);

    return (
        <Modal open={open} onClose={onClose}>
            <Container>
                <h2>Run Branch for {repo.name}</h2>
                <LoadingContainer open={branches === undefined}>
                    { branches ? (
                        <>
                            {branches.map((branch, index) => (
                                <div className={'item'} onClick={() => {
                                    agent.putRunRepoBranch(repo.withoutBranch, branch).then(() => {
                                        onClose();
                                    });
                                }} style={{cursor: 'pointer'}} key={index}>{branch}</div>
                            ))}
                        </>
                    ) : (
                        <p>Loading branches...</p>
                    )}
                </LoadingContainer>
            </Container>
        </Modal>
    );
}

